var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-dialog',{attrs:{"title":_vm.title,"closable":false,"layout":"column","btns":_vm.btns},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_vm._v("\n    购买后可报名参加对应课包次数的任意同类型活动\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }